/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
 */
export interface GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];


